import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import Button from '@material-ui/core/Button'
import ButtonBase from '@material-ui/core/ButtonBase'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { withStyles } from '@material-ui/core/styles'

import Heading3 from '../styleguide/Heading3'

export const sharedStyles = () => ({
  headingStyle: {
    textAlign: 'center',
    textDecoration: 'none',
    textTransform: 'uppercase',
    marginBottom: 10,
    minHeight: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#303c39',
    ':hover > &': {
      color: '#e40045'
    }
  },
  navigationCircleButtonStyle: {
    width: 130,
    height: 130,
    backgroundColor: '#838a92',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: '#303c49',
    borderRadius: 24,
    '-webkit-box-shadow': 'rgba(0, 0, 0, 0.2) 0px 3px 3px -2px, rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px',
    '-moz-box-shadow': 'rgba(0, 0, 0, 0.2) 0px 3px 3px -2px, rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px',
    boxShadow: 'rgba(0, 0, 0, 0.2) 0px 3px 3px -2px, rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px',
    transition: "all 0.2s",
    ':hover > &': {
      color: '#e40045',
      boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px"
    }
  }
})

const styles = theme => ({
  ...sharedStyles(),
  linkButtonRootStyle: {
    fontSize: theme.typography.pxToRem(12),
    fontFamily: 'Arial, sans-serif',
    lineHeight: 'normal',
    fontWeight: 'normal',
    textTransform: 'none',
    width: 155,
    minHeight: 38,
    padding: '12px 10px',
    margin: '4px 0',
    backgroundColor: '#e40045',
    borderRadius: 4,
    color: '#fff',
    '&:hover': {
      backgroundColor: '#b10036'
    }
  },
  menuItemStyle: {
    padding: 0,
    height: 'inherit',
    maxWidth: 130,
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '-webkit-column-break-inside': 'avoid',
    'page-break-inside': 'avoid',
    'break-inside': 'avoid'
  },
  menuListStyle: {
    backgroundColor: 'transparent',
    padding: 0,
    marginTop: '6px'
  },
  menuListTwoColumnStyle: {
    columnCount: 2
  },
  menuPaperStyle: {
    backgroundColor: 'transparent'
  },
  menuPaperTwoColumnStyle: {
    transform: 'translateX(-25%)'
  }
})

class EntryScreenMenu extends React.Component {
  state = {
    anchorEl: null
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  render() {
    const { anchorEl } = this.state
    const {
      classes: {
        headingStyle,
        linkButtonRootStyle,
        menuItemStyle,
        menuListStyle,
        menuListTwoColumnStyle,
        menuPaperStyle,
        menuPaperTwoColumnStyle,
        navigationCircleButtonStyle
      },
      menuTitle,
      menuImage,
      menuItems
    } = this.props

    const renderTwoColumnLayout = menuItems.length > 6

    return (
      <Fragment>
        <Heading3
          bold
          className={headingStyle}
          style={anchorEl && { color: '#e40045' }}
        >
          <span>{menuTitle}</span>
        </Heading3>
        <ButtonBase
          disableRipple
          classes={{ root: navigationCircleButtonStyle }}
          aria-owns={anchorEl ? `${menuTitle}-menu` : null}
          aria-haspopup="true"
          onClick={this.handleClick}
          style={{
            backgroundImage: `url(${menuImage})`,
            color: anchorEl && '#e40045'
          }}
        />
        <Menu
          classes={{
            paper: classNames(
              menuPaperStyle,
              renderTwoColumnLayout && menuPaperTwoColumnStyle
            )
          }}
          id={`${menuTitle}-menu`}
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}
          elevation={0}
          getContentAnchorEl={null}
          MenuListProps={{
            className: classNames(
              menuListStyle,
              renderTwoColumnLayout && menuListTwoColumnStyle
            )
          }}
        >
          {menuItems.map(({ linkUrl, title }) => (
            <MenuItem
              key={title}
              onClick={() => {
                this.handleClose()
              }}
              classes={{ root: menuItemStyle }}
            >
              <Button
                classes={{ root: linkButtonRootStyle }}
                component={Link}
                to={linkUrl}
              >
                {title}
              </Button>
            </MenuItem>
          ))}
        </Menu>
      </Fragment>
    )
  }
}

export default withStyles(styles)(EntryScreenMenu)

EntryScreenMenu.propTypes = {
  classes: PropTypes.object,
  menuItems: PropTypes.array.isRequired,
  menuTitle: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/components/EntryScreenMenu.js